// TODO: Remove no-shadow eslint disable after fixed: https://github.com/typescript-eslint/typescript-eslint/issues/2484
// eslint-disable-next-line no-shadow
export enum CouponMutationTypes {
    SET_COUPON_SUCCESS = 'SET_COUPON_SUCCESS',
    SET_COUPON_ERROR = 'SET_COUPON_ERROR'
  }
  